define('formkit/view/form.object/rule/rule.item.view',['require','exports','module','uikit/uikit','./condition.collection.view','../../../templates'],function(require, exports, module){
  var UIKit                   = require('uikit/uikit');
  var ConditionCollectionView = require('./condition.collection.view');
  var Templates               = require('../../../templates');

  var RuleItemHeaderView = UIKit.Header.extend({
    template: Templates.App['rule.item.header'],

    option: {
      text:  '',
      index: -1
    },

    internalViewBindings: {
      headerTextView: {
        text: 'text'
      },
      headerIndexView: {
        text: 'index'
      }
    },

    internalViewOptions: {
      headerTextView: {
        type: UIKit.Text
      },
      headerIndexView: {
        type: UIKit.Text
      },
      removeButtonView: {
        type: UIKit.Button,
        inline: true,
        icon: 'remove',
        color: 'red',
        text: 'remove group'
      }
    }
  });

  var RuleItemView = UIKit.ItemView.extend({

    template: Templates.App['rule.item'],

    options: {
      index: -1
    },

    internalViewBindings: {
      ruleHeaderView: {
        index: 'index'
      }
    },

    internalViewOptions: {
      conditionCollectionView: function() {
        return {
          type: ConditionCollectionView,
          collection: this.model.get('conditions'),
          form: this.getOption('form')
        }
      },
      ruleHeaderView: function() {
        return {
          type: RuleItemHeaderView,
          className: 'ui top attached block header',
          tagName: 'h4',
          text: 'Rule Group',
          index: this.index
        }
      },
      ruleDividerView: function() {
        return {
          type: UIKit.Divider,
          horizontal: true,
          visible: this.getOption('index') > 1,
          text: 'or'
        }
      }
    },

    onRuleHeaderViewRemoveButtonViewPress: function () {
      this.triggerMethod('remove:rule', this.model);
    },

    onInjectedRuleDividerView: function() {
      this.on('change:index', function(view, newValue, oldValue) {
        this.ruleDividerView.visible = newValue > 1;
      })
    }
  });

  module.exports = RuleItemView;
});

